import FInput from '@/plugins/form/FInput';
import FDictionaryCountry from '@/modules/Dictionary/Country/Select';
import FDictionaryRegion from '@/modules/Dictionary/Region/Select';
import FDictionaryCity from '@/modules/Dictionary/City/Select';

export function setItemName({ required = true, length = 50, lat = true } = {}) {
  this.name = new FInput({
    name: 'Name',
    label: 'Название',
  });
  if (required) {
    this.name.setValidatorRequire();
  }
  if (length) {
    this.name.setValidatorMax(length);
  }
  if (lat) {
    this.name.$subscribe(() => {
      if (!this.id.value) {
        this.nameLat.setLat(this.name.value);
      }
    });
  }
  this.setItem('name', this.name);
}

export function setItemNameLat({ required = false, length = 50 } = {}) {
  this.nameLat = new FInput({
    name: 'NameLat',
    label: 'Название (лат)',
  });
  if (required) {
    this.nameLat.setValidatorRequire();
  }
  if (length) {
    this.nameLat.setValidatorMax(length);
  }
  this.setItem('nameLat', this.nameLat);
}

export function setItemNameTranslit({ required = false, length = 50 } = {}) {
  this.nameTranslit = new FInput({
    name: 'NameTranslit',
    label: 'Название (транслит)',
  });
  if (required) {
    this.nameTranslit.setValidatorRequire();
  }
  if (length) {
    this.nameTranslit.setValidatorMax(length);
  }
  this.setItem('nameTranslit', this.nameTranslit);
}

export function setItemCode({ required = false, length = 50 } = {}) {
  this.code = new FInput({
    name: 'Code',
    label: 'Код',
  });
  if (required) {
    this.code.setValidatorRequire();
  }
  if (length) {
    this.code.setValidatorMax(length);
  }
  this.setItem('code', this.code);
}

export function setItemCountry({ required = false } = {}) {
  this.country = new FDictionaryCountry({
    name: 'CountryId',
    label: 'Страна',
    required: true,
  });
  if (required) {
    this.country.setValidatorRequire();
  }
  this.setItem('country', this.country);
}

export function setItemRegion({ required = false } = {}) {
  this.region = new FDictionaryRegion({
    name: 'RegionId',
    label: 'Регион',
  });
  if (required) {
    this.region.setValidatorRequire();
  }
  this.region.country = this.country;
  this.setItem('region', this.region);
}

export function setItemCity({ required = false } = {}) {
  this.city = new FDictionaryCity({
    name: 'CityId',
    label: 'Город',
  });
  if (required) {
    this.city.setValidatorRequire();
  }
  this.city.country = this.country;
  this.city.region = this.region;
  this.setItem('city', this.city);
}
